// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3qxYB","errors":"Errors_errors__1_cZU"};